import { css } from 'linaria';

export const housePageDistribution = css`
  display: flex;
  column-gap: 32px;
  margin-bottom: 32px;

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const housePageDistributionBanner = css`
  width: 372px;
  height: 244px;

  @media (--only-desktop) {
    width: 292px;
    height: 220px;
  }

  @media (--only-tablet) {
    width: 198px;
    height: 245px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: unset;
  }

  img {
    width: 100%;
  }
`;
